export const urlValidationPattern = {
  message: "validationErrors.invalidUrl",
  value: new RegExp("^https?://"),
};

export const REQUIRED_ERROR_KEY = "validationErrors.required";
